import { useEffect, useState } from "react";

// Componentes
import { Table, Card, CardBody, CardTitle } from "reactstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../../../components/Paginationv3";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
import DeleteButton from "../../../../components/Buttons/DeleteButton";

// Modais
import { ModalNewEnabledEvent } from "./modals/ModalNewEnabledEvent";

// Services
import {
  fetchEnabledEvents,
  deleteEnabledEvent,
} from "../../../../utils/services/portalBoticario";
import { getEventByEvent } from "../../../../utils/services/events";

const EnabledEvents = (props) => {
  const location = useLocation();
  const token = props.state.global_user_data.data.token;

  // state modais
  const [newModal, setNewModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showSuccessDelete, setShowSuccessDelete] = useState(false);
  const [showErrorDelete, setShowErrorDelete] = useState(false);

  // state de dados
  const [allItems, setAllItems] = useState([]);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [eventNames, setEventNames] = useState({});

  // state de filtros
  const [search, setSearch] = useState("");

  // state de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // carrega todos os eventos habilitados de uma vez e resolve os nomes em paralelo
  const getEnabledEvents = async () => {
    try {
      const first = await fetchEnabledEvents(token, 1, 1);
      const total = first.data.total || 0;
      if (total === 0) return;

      const result = await fetchEnabledEvents(token, 1, total);
      const fetchedItems = result.data.items || [];

      const uniqueIds = [...new Set(fetchedItems.map((i) => i.eventId))];
      const entries = await Promise.all(
        uniqueIds.map(async (id) => {
          const res = await getEventByEvent(id);
          if (res?.message !== "findEventoById") return [id, null];
          const title = res.data?.title || res.data?.nome || null;
          return [id, title];
        })
      );
      const map = {};
      entries.forEach(([id, title]) => {
        if (title) map[id] = title;
      });
      setEventNames(map);

      // guarda apenas os itens com evento válido (não-órfãos)
      setAllItems(fetchedItems.filter((i) => map[i.eventId]));
    } catch (error) {
      console.error("Erro ao buscar eventos habilitados:", error);
    }
  };

  useEffect(() => {
    getEnabledEvents();
  }, []);

  const handleDelete = (item) => {
    setItemToDelete(item);
    setConfirmDelete(true);
  };

  // aplica busca por nome sobre todos os itens válidos
  const filteredItems = allItems.filter((item) => {
    if (!search.trim()) return true;
    return eventNames[item.eventId].toLowerCase().includes(search.toLowerCase());
  });

  // fatia para a página atual
  const displayedItems = filteredItems.slice(
    (currentIndex - 1) * itemsPerPage,
    currentIndex * itemsPerPage
  );

  return (
    <>
      {newModal && (
        <ModalNewEnabledEvent
          isOpen={newModal}
          toggle={() => setNewModal(false)}
          jwt={token}
          refetch={getEnabledEvents}
        />
      )}

      {confirmDelete && (
        <SweetAlert
          title="Deseja desabilitar este evento?"
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            try {
              await deleteEnabledEvent(itemToDelete.eventId, token);
              await getEnabledEvents();
              setConfirmDelete(false);
              setShowSuccessDelete(true);
            } catch (error) {
              console.error("Erro ao desabilitar evento:", error);
              setConfirmDelete(false);
              setShowErrorDelete(true);
            }
          }}
          onCancel={() => setConfirmDelete(false)}
        >
          O evento será removido da lista de habilitados.
        </SweetAlert>
      )}

      {showSuccessDelete && (
        <SweetAlert
          title="Desabilitado!"
          success
          onConfirm={() => setShowSuccessDelete(false)}
        >
          Evento desabilitado com sucesso!
        </SweetAlert>
      )}

      {showErrorDelete && (
        <SweetAlert
          title="Erro"
          error
          onConfirm={() => setShowErrorDelete(false)}
        >
          Não foi possível desabilitar o evento. Tente novamente.
        </SweetAlert>
      )}

      <Card>
        <CardBody>
          <CardTitle>Eventos Habilitados</CardTitle>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexWrap: "wrap",
              gap: 10,
              marginBottom: 16,
            }}
          >
            <div style={{ flex: 1, maxWidth: 320 }}>
              <label className="form-label" style={{ marginBottom: 4 }}>
                Nome do evento
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nome do evento"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentIndex(1);
                }}
              />
            </div>

            <div className="header-btns-container">
              <ActionButtonRounded
                title="Habilitar Evento"
                onClick={() => setNewModal(true)}
              />
            </div>
          </div>

          {/* Tabela */}
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="thead-light">
                <tr>
                  <th>Evento</th>
                  <th>ID do Evento</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {displayedItems.length === 0 ? (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      Nenhum evento habilitado encontrado.
                    </td>
                  </tr>
                ) : (
                  displayedItems.map((item) => (
                    <tr key={item.eventId}>
                      <td>{eventNames[item.eventId]}</td>
                      <td style={{ wordBreak: "break-all", color: "#888", fontSize: 12 }}>
                        {item.eventId}
                      </td>
                      <td>
                        <DeleteButton onClick={() => handleDelete(item)} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <Pagination
        data={displayedItems}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        countData={filteredItems.length}
        maxItemPerPage={itemsPerPage}
        setMaxItemPerPage={setItemsPerPage}
        maxPageButtonsToShow={3}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(EnabledEvents);
